import React, {useEffect} from 'react';
import Authenticated from "../../components/Authenticated";
import {Outlet, useNavigate, useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {AUTHENTICATED, setEvent} from "../../slices/sessionSlice";
import {
    useLazyGetCalendarEventsQuery,
    useLazyGetEventQuery,
    useLazyGetUserEventServicesQuery
} from "../../slices/apiSlice";
import {findMostRelevantEvent} from "../../util/standards-util";

const EventPage = () => {
    const session = useSelector(state => state.session)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [searchParams, setSearchParams] = useSearchParams();
    const queryEventId = searchParams.get("eventId")

    const [getEventServices, getEventServicesResult] =
        useLazyGetUserEventServicesQuery()

    const [getCalendarEvents, getCalendarEventsResult] =
        useLazyGetCalendarEventsQuery()

    const [getEvent, getEventResult] =
        useLazyGetEventQuery()

    useEffect(() => {
        if (queryEventId && !isNaN(queryEventId)) {
            getEvent(Number(queryEventId))
        }
    }, []);

    useEffect(() => {
        if (getEventResult.isSuccess && getEventResult.data) {
            dispatch(setEvent(getEventResult.data))
        }
    }, [getEventResult]);

    useEffect(() => {
        if (session.status === AUTHENTICATED && !session.event && (!queryEventId || !getEventResult.data)) {
            getEventServices()
        }
    }, [session.status]);

    useEffect(() => {
        if (getEventServicesResult.isSuccess) {
            const event = findMostRelevantEvent(getEventServicesResult.data)
            if (event) {
                dispatch(setEvent(event))
            }
            else {
                getCalendarEvents()
            }
        }
    }, [getEventServicesResult]);

    useEffect(() => {
        if (getCalendarEventsResult.isSuccess) {
            const event = findMostRelevantEvent(getCalendarEventsResult.data)
            if (event) {
                dispatch(setEvent(event))
            }
            else {
                navigate('/calendar')
            }
        }
    }, [getCalendarEventsResult]);

    return (
        <Authenticated>
            <Outlet/>
        </Authenticated>
    );
};

export default EventPage;